module.exports = __webpack_public_path__ + "build/desktop/a/img/meal.9f5cdfdade63d0a5c73f679bad76ef14.svg";